<template>
    <div>
        <common-table :form-fields="formFields"
                      :table-columns="tableColumns"
                      :url="url"
                      :searchs="searchs"
                      :permission="permission"
                      :operate="operate"
                      ref="table"
        />

        <div class="dialog">
            <el-dialog :title="domainTitle"
                       :visible.sync="domainVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       width="35%">
                <div class="dialog_body" style="padding-bottom: 1rem">
                    <el-form label-position="right" status-icon
                             :model="domainForm" ref="domainForm">
                        <el-form-item prop="domain" :rules="[{message: '请输入域名，多域名请换行', trigger: 'blur', required: true}]">
                            <el-input type="textarea"
                                      size="medium"
                                      :autosize="{minRows: 4}"
                                      placeholder="请输入域名，多域名请换行"
                                      v-model="domainForm.domain"
                                      class="domain"
                                      clearable>
                            </el-input>
                        </el-form-item>
                        <el-button class="mb-10" type="primary" size="mini" @click="submitDomain('domainForm')">添 加</el-button>
                        <el-button class="mb-10" icon="el-icon-delete" type="danger" size="mini" @click="deleteBatch">批量删除</el-button>
                    </el-form>

                    <el-table
                            ref="multipleTable"
                            :data="domains"
                            tooltip-effect="dark"
                            style="width: 100%"
                            @selection-change="handleSelectionChange">
                        <el-table-column
                                align="center"
                                type="selection"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="domain"
                                label="域名">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <el-popconfirm :title="'确定要删除吗？'" @onConfirm="deleteDomain(scope.row)">
                                    <el-button slot="reference" icon="el-icon-delete" type="danger" size="mini">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
        </div>

        <div class="dialog">
            <el-dialog title="更换父级"
                       :visible.sync="agentParentVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="agentParentVisibleClose('agentParentForm')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="70px"
                             :model="agentParentForm" ref="agentParentForm">
                        <el-form-item label="代理" prop="username" :rules="[{message: '请选择代理', trigger: 'blur', required: true}]">
                            <el-input placeholder="代理" v-model="agentParentForm.username" :style="'pointer-events: none;'"/>
                        </el-form-item>
                        <el-form-item label="父代理" prop="parentId" :rules="[{message: '请选择父代理', trigger: 'blur', required: true}]">
                            <el-select v-model="agentParentForm.parentId" placeholder="请选择类型" clearable>
                                <el-option v-for="(option, index) in topAgents" :key="index" :label="option.username" :value="option.id"/>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="agentParentVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitAgentParentForm('agentParentForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <!--重置密码-->
        <div class="dialog">
            <el-dialog title="重置密码"
                       :visible.sync="resetPwdVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetPwdVisibleClose('resetPwdForm')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="80px"
                             :model="resetPwdForm" ref="resetPwdForm">
                        <el-form-item label="代理" prop="username" :rules="[{message: '请选择代理', trigger: 'blur', required: true}]">
                            <el-input placeholder="代理" v-model="resetPwdForm.username" :style="'pointer-events: none;'"/>
                        </el-form-item>
                        <el-form-item label="新密码" prop="password" :rules="[{message: '新密码不能为空', trigger: 'blur', required: true}]">
                            <el-input type="password" show-password placeholder="新密码" v-model="resetPwdForm.password"/>
                        </el-form-item>
<!--                        <el-form-item label="验证码" prop="googleCode" :rules="[{message: '谷歌验证码不能为空', trigger: 'blur', required: true}]">
                            <el-input placeholder="谷歌验证码" v-model="resetPwdForm.googleCode"/>
                        </el-form-item>-->
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="resetPwdVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitResetPwdForm('resetPwdForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    import message from "../../utils/message";
    export default {
        name: "Agent",
        components: {CommonTable},
        data() {
            return {
                rechargeVisible: false,
                rechargeForm: {
                    agentId: '',
                    username: '',
                    amount: '',
                    expound: ''
                },
                domainTitle: '',
                domainVisible: false,
                domainForm: {
                    agentId: '',
                    domain: '',
                },
                domains: [],
                domainIds: [],
                agent: {},

                resetPwdVisible: false,
                resetPwdForm: {
                    id: '',
                    username: '',
                    password: '',
                    googleCode: ''
                },

                topAgents: null,
                agentParentForm: {
                    id: '',
                    parentId: '',
                    username: '',
                },
                agentParentVisible: false,
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'parentName',
                    placeholder: '上级',
                    type: 'input'
                },
                {
                    name: 'fissionable',
                    placeholder: '可添加下级',
                    type: 'select',
                    selectValue:[
                        {
                            key: "1",
                            value: "开启"
                        },
                        {
                            key: "0",
                            value: "关闭"
                        }
                    ]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    add: 'agent:add',
                    update: 'agent:update',
                    delete: 'agent:delete',
                    deleteBatch: 'agent:deleteBatch'
                },
                url: {
                    get: '/agent/listByCondition',
                    add: '/agent/add',
                    update: '/agent/update',
                    delete: '/agent/delete/',
                    delete_batch: '/agent/deleteBatch',
                    status: '/agent/status'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '100',
                }, {
                    field: 'adminId',
                    label: '管理员ID',
                    show: false,
                    width: '',
                }, {
                    field: 'username',
                    label: '代理名',
                    show: true,
                    width: '',
                }/*,{
                    field: 'phone',
                    label: '手机号',
                    show: true,
                    width: '',
                },{
                    field: 'email',
                    label: '邮箱',
                    show: true,
                    width: '',
                }*/, {
                    field: 'parentName',
                    label: '上级代理',
                    /*selectUrl: '/agent/all',
                    selectData: [],
                    show: {
                        type: 'select'
                    },*/
                    show: true,
                    width: '',
                }, {
                    field: 'level',
                    label: '级别',
                    show: true,
                    width: '',
                }, {
                    field: 'ratio',
                    label: '佣金比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }/*, {
                    field: 'money',
                    label: '金额()',
                    show: true,
                    width: '',
                }*/,{
                    field: 'fissionable',
                    label: '添加下级',
                    show: {
                        type: 'status',
                        url: '/agent/update/fissionable'
                    },
                    values: [{
                        type: 'success',
                        key: 1,
                        value: '开启'
                    }, {
                        type: 'warning',
                        key: 0,
                        value: '关闭'
                    }],
                    width: '',
                    confirm: 'username',
                    permission: 'agent:update:fissionable'
                },{
                    field: 'secretKey',
                    label: '谷歌二维码',
                    show: false,
                    width: '',
                    img: true,
                    qrCode: true
                },{
                    field: 'status',
                    label: '状态',
                    show: true,
                    width: '90',
                    status: true,
                }, {
                    field: 'cycle',
                    label: '有效期(天)',
                    show: true,
                    width: '',
                }, {
                    field: 'expirationTime',
                    label: '过期时间',
                    show: true,
                    width: '',
                }, {
                    field: 'pId',
                    label: 'pId',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加代理',
                    updateTitle: '修改代理',
                    labelWidth: '100px',
                    toTree: false,
                    model: [{
                        field: 'parentId',
                        label: '上级代理',
                        type: 'select',
                        placeholder: '请选择上级代理',
                        rules:[{required: false, message: '请选择上级代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'username',
                        label: '用户名',
                        type: 'input',
                        placeholder: 'Username',
                        rules:[{
                            message: '请输入用户名', trigger: 'blur', required: true
                        },{
                            max: 12, message: '用户名在12个字符内', trigger: 'blur', required: true
                        },{
                            pattern: /^\S*$/, message: '用户名不能包含空格',  trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                        onlyShow: true,
                    },{
                        field: 'password',
                        label: '密码',
                        type: 'password',
                        placeholder: 'Password',
                        rules: [{
                            message: '请输入密码', trigger: 'blur', required: true
                        },{
                            min: 6, max: 18, message: '密码在6~18个长度内', trigger: 'blur', required: true
                        },{
                            pattern: /^\S*$/, message: '密码不能包含空格',  trigger: 'blur', required: true
                        }],
                        add: true,
                        update: false,
                    }/*,{
                        field: 'phone',
                        label: '手机号：',
                        type: 'number',
                        maxlength: 11,
                        placeholder: 'Phone',
                        rules: [{
                            message: '请输入手机号', trigger: 'blur', required: false
                        },{
                            pattern: /^1[34578]\d{9}$/, message: '手机号格式错误',  trigger: 'blur'
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'email',
                        label: '邮箱：',
                        type: 'input',
                        placeholder: 'Email',
                        rules: [{
                            message: '请输入邮箱', trigger: 'blur', required: false
                        },{
                            type: 'email', message: '邮箱格式错误', trigger: 'blur'
                        }],
                        add: true,
                        update: true,
                    }*/, {
                        field: 'ratio',
                        label: '佣金比例',
                        type: 'money',
                        placeholder: '佣金比例(%)',
                        rules: [{
                            message: '请输入佣金比例', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'fissionable',
                        label: '添加下级',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '开启',
                        }, {
                            id: 0,
                            name: '关闭',
                        }],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: false,
                    }, {
                        field: 'cycle',
                        label: '有效期',
                        type: 'input',
                        placeholder: '有效期(天)',
                        rules:[{
                            message: '请输入有效期(天)', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                        default: 0
                    }/*, {
                        field: 'money',
                        label: '佣金金额：',
                        type: 'input',
                        placeholder: '金额',
                        rules: [{
                            message: '请输入金额', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                    }*//*, {
                        field: 'domain',
                        label: '域名',
                        type: 'textarea',
                        placeholder: '域名，多域名请换行',
                        rules:[{
                            message: '请输入域名，多域名请换行', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: false,
                        tip: '多域名请换行',
                        minRows: 4
                    }*/, {
                        field: 'frontTemplateId',
                        label: '前端模板',
                        type: 'select',
                        placeholder: '前端模板',
                        rules:[{required: false, message: '请选择前端模板', trigger: 'blur'}],
                        selectUrl: '/frontTemplate/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }]
                },
                operate: [/*{
                    icon: 'el-icon-discount',
                    type: 'text',
                    text: '充值',
                    handle: (row) => {
                        this.rechargeForm.agentId = row.id;
                        this.rechargeForm.username = row.username;
                        this.rechargeVisible = true;
                    }
                }, */{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '重置密码',
                    handle: (row) => {
                        this.resetPwdForm.id = row.id;
                        this.resetPwdForm.username = row.username;
                        this.resetPwdVisible = true;
                    }
                }, {
                    icon: 'el-icon-discount',
                    type: 'text',
                    text: '绑定域名',
                    handle: (row) => {
                        this.agent = row;
                        this.getDomains();
                    }
                }, {
                    icon: 'el-icon-umbrella',
                    type: 'text',
                    text: '更换父级',
                    exist: (row) => {
                        return (!row.parentId || row.parentId === 0) && this.$refs.table.havePermission('agent:update:parent')
                    },
                    handle: (row) => {
                        this.agentParentForm.id = row.id;
                        this.agentParentForm.username = row.username;
                        if (this.topAgents && this.topAgents.length >= 0) {
                            this.agentParentVisible = true
                        } else {
                            this.getTopAgents()
                        }
                    }
                }]
            }
        },
        methods: {
            getDomains() {
                this.domainIds = [];
                this.$axios.post({
                    url: '/agentDomain/agent/'+this.agent.id,
                    loading: false,
                    success: (res) => {
                        this.domains = res.data;
                        this.domainForm.agentId = this.agent.id;
                        this.domainTitle = `域名绑定[${this.agent.username}]`;
                        this.domainVisible = true;
                    }
                })
            },
            submitDomain(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post({
                            url: '/agentDomain/addBatch',
                            data: this.domainForm,
                            confirm: '确定添加？',
                            success: (res) => {
                                if (res.code === 0){
                                    this.getDomains();
                                    this.$message.success('域名添加成功');
                                    this.domainForm.domain = '';
                                }else {
                                    this.$message.error(res.msg ? res.msg:'域名添加失败');
                                }
                            },
                            error: () => {
                                this.$message.error('出错了');
                            }
                        });
                    }
                })
            },
            //单个删除
            deleteDomain(row){
                this.$axios.post({
                    url: '/agentDomain/delete/' + row.id,
                    success: (res) => {
                        if (res.code === 0){
                            this.$message.success('删除成功');
                            this.getDomains();
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            handleSelectionChange(val) {
                this.domainIds = [];
                for (let i = 0; i < val.length; i++){
                    this.domainIds.push(val[i].id);
                }
            },
            deleteBatch() {
                if (this.domainIds.length <= 0){
                    this.$message.warning('请选中要删除的数据');
                    return;
                }
                this.$axios.post({
                    url: '/agentDomain/deleteBatch',
                    data: this.domainIds,
                    confirm: '此操作将删除选中的数据, 是否继续?',
                    success: (res) => {
                        if (res.code === 0){
                            this.getDomains();
                            this.$message.success('删除成功');
                        }else {
                            this.$message.error('删除失败');
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            agentParentVisibleClose(formName) {
                this.$refs[formName].resetFields();
                this.agentParentForm.username = ''
            },
            submitAgentParentForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post({
                            url: '/agent/update/parent',
                            confirm: `确定更换${this.agentParentForm.username}的父级代理？`,
                            data: this.agentParentForm,
                            success: (res) => {
                                if (res.code === 0) {
                                    this.$message.success(`更换${this.agentParentForm.username}的父级代理成功`)
                                    this.$refs.table.getData();
                                    this.agentParentVisible = false;
                                } else {
                                    this.$message.error(`更换${this.agentParentForm.username}的父级代理失败`)
                                }
                            }
                        })
                    }
                })
            },
            getTopAgents() {
                this.$axios.post({
                    url: '/agent/top',
                    success: (res) => {
                        if (res.code === 0) {
                            this.topAgents = res.data;
                            this.agentParentVisible = true;
                        } else {
                            this.$message.error('获取顶级代理出错');
                        }
                    }
                })
            },
            submitResetPwdForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post({
                            url: '/agent/password/reset',
                            data: this.resetPwdForm,
                            success: (res) => {
                                if (res.code === 0) {
                                    this.resetPwdVisible = false;
                                    message.success("重置密码成功");
                                } else {
                                    message.error(res.msg || "重置密码失败");
                                }
                            }
                        });
                    }
                })
            },
            resetPwdVisibleClose(formName) {
                this.$refs[formName].resetFields();
                this.resetPwdForm.agentId = null;
                this.resetPwdForm.username = '';
            },
        },
    }
</script>

<style scoped>
    .domain {
        max-width: 350px;
    }
</style>
